// extracted by mini-css-extract-plugin
export var boxItems = "_65-1";
export var boxItemsLg = "_65-2";
export var button = "_65-7";
export var buttonHoverless = "_65-9";
export var buttonLg = "_65-8";
export var filterGroupBox = "_65-0";
export var icon = "_65-3";
export var iconSecondary = "_65-6";
export var iconWrapper = "_65-4";
export var iconWrapperLg = "_65-5";
export var truncatedLabel = "_65-a";